<template>
  <div class="news-tab">
    <news-filter class="news-tab__header"
                 v-model="newsFilter"
                 :items="newsCmsTags"
    />
    <div class="news-tab__content">
      <news-block v-for="newsItem in renderedNewsItems"
                  :key="newsItem.newsItemId"
                  class="news-tab__content-article"
                  :item="newsItem"
                  :tags="viewModel.cmsTags"
      />
    </div>
    <div class="news-tab__paginator">
      <pagination-control v-model="currentPage"
                          :per-page="newsItemsPerPage"
                          :total-rows="filteredNewsItems.length"
      />
    </div>
  </div>
</template>

<script lang="ts">
import NewsFilter from "./NewsFilter.vue";
import NewsBlock from "./NewsBlock.vue";
import PaginationControl from "@/common/controls/PaginationControl.vue";

export default {
  components: {
    NewsFilter,
    NewsBlock,
    PaginationControl,
  },
  props: {
    viewModel: Object,
  },
  data() {
    return {
      newsFilter: [],
      currentPage: 1,
      newsItemsPerPage: 6,
    };
  },
  computed: {
    newsItems() {
      return this.viewModel.items || [];
    },
    filteredNewsItems() {
      const isAll = this.newsFilter.length === 0;
      return isAll
          ? this.newsItems
          : this.newsItems.filter(newsItem => 
              this.newsFilter.find(newsFilterTag => 
                  newsItem.cmsTagIds.includes(newsFilterTag)));
    },
    renderedNewsItems() {
      const start = (this.currentPage - 1) * this.newsItemsPerPage;
      return this.filteredNewsItems.slice(start, start + this.newsItemsPerPage);
    },
    newsCmsTags() {
      return [
        ...this.viewModel.cmsTags
      ];
    },
  },
  watch: {
    newsFilter: {
      handler() {
        this.currentPage = 1;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.news-tab {
  position: relative;
  display: flex;
  flex-flow: column;
  gap: 20px;
}

.news-tab__content {
  display: flex;
  flex-flow: column;
  gap: 20px;
}

.news-tab__content-article {
  padding: 20px 24px;
  border: none;
  box-shadow: var(--shadow);
  border-radius: var(--border-radius-md);
}
</style>
